<template>
  <v-content>
    <v-container fluid>
      <v-layout column>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <h1 style="font-family: Lato; text-align: center">
            <span style="margin-left: 10px; margin-right: 10px; color: white">
              <span class="capitalLetter">D</span>uplicates
            </span>
          </h1>
          <hr style="margin-bottom: 30px; margin-left: 30px; margin-right: 30px">
        </v-flex>
        <v-container v-for="(serial,index) in duplicateDataKeys" :key="index" style="margin-left: 30px; margin-right: 30px">
          <!-- <v-flex xs12 sm12 md12 lg12 xl12> -->
          <v-layout row wrap>
            <v-flex shrink>
              <v-alert
              :value="true"
              color="secondary"
              outline
              >
                {{serial}}
              </v-alert>
            </v-flex>
          </v-layout>
          <!-- </v-flex> -->
          <v-layout row wrap>
            <div v-for="(warehouse,index2) in duplicateData[serial]" :key="index2">
              <v-flex shrink>
                <v-chip color="primary" :key="index">{{warehouse}}</v-chip>
              </v-flex>
            </div>
          </v-layout>
          <v-spacer/>
        </v-container>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import getSitePass from "../sitepass";

export default {
  name: "dupes",
  data: function() {
    return {
      duplicateData: [],
      duplicateDataKeys: [],
      isLoading: true,
      search: "",
    };
  },
  methods: {
    getDuplicates() {
      axios
        .get(`${process.env.VUE_APP_backend_url}/duplicateChecker`, {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.duplicateData = response.data;
          this.duplicateDataKeys = Object.keys(this.duplicateData)
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initialize() {
      this.getDuplicates();
    }
  },
  created() {
    this.initialize();
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/duplicatesView.vue